import React, { FC } from 'react';
import cx from 'classnames';

import { CardProps } from 'types/components';

import styles from './styles.module.css';

const Card: FC<CardProps> = ({ className, ...props }) => (
  <div className={cx(styles.root, className)} {...props} />
);

export default Card;
